module.exports = __webpack_public_path__ + "img/zhi.2925e16c.png";